const VIACEP_URL = 'https://viacep.com.br/ws';

class ShippingCalculatorPdp extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.shipping-pdp__submit');
    this.zipInput = this.querySelector('#AddressZipCalculatorPdp');
    this.resultsBox = this.querySelector('.shipping-calculator__results');
    this.resultsList = this.querySelector('.shipping-calculator__results-list');
    this.spinner = this.querySelector('.loading-overlay__spinner');
    this.messageEl = this.querySelector('[data-shipping-pdp-message]');

    if (this.button) {
      this.button.addEventListener('click', this.onCalculate.bind(this));
    }
  }

  getVariantId() {
    const fromForm =
      document.querySelector('product-info input.product-variant-id[name="id"]:not([disabled])') ||
      document.querySelector('product-info input[name="id"]:not([disabled])') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    if (fromForm && fromForm.value) {
      return fromForm.value;
    }
    return (
      window.ShopifyAnalytics?.meta?.selectedVariantId ||
      window.meta?.product?.selectedVariantId ||
      window.meta?.product?.variants?.[0]?.id
    );
  }

  hideMessage() {
    if (!this.messageEl) return;
    this.messageEl.textContent = '';
    this.messageEl.classList.add('hidden');
  }

  showMessage(text) {
    if (!this.messageEl) return;
    this.messageEl.textContent = text;
    this.messageEl.classList.remove('hidden');
  }

  /**
   * Consulta o CEP em https://viacep.com.br/ e devolve a UF (ex.: SP).
   * @see https://viacep.com.br/
   */
  async fetchProvinceFromCep(zipDigits) {
    const res = await fetch(`${VIACEP_URL}/${zipDigits}/json/`);
    if (res.status === 400) {
      throw new Error('invalid_cep');
    }
    if (!res.ok) {
      throw new Error('viacep_http');
    }
    const data = await res.json();
    if (data.erro === true) {
      throw new Error('cep_not_found');
    }
    if (!data.uf || typeof data.uf !== 'string') {
      throw new Error('viacep_invalid');
    }
    return data.uf.trim();
  }

  async onCalculate() {
    if (window.pdpCalculatingShipping) {
      return;
    }

    this.hideMessage();
    if (this.resultsList) {
      this.resultsList.innerHTML = '';
    }
    if (this.resultsBox) {
      this.resultsBox.classList.add('hidden');
    }

    const zip = this.zipInput.value.replace(/\D/g, '');
    if (!zip || zip.length !== 8) {
      this.showMessage(this.dataset.invalidCep);
      return;
    }

    const variantId = this.getVariantId();
    if (!variantId) {
      this.showMessage(this.dataset.productError);
      return;
    }

    let state;
    try {
      state = await this.fetchProvinceFromCep(zip);
    } catch (err) {
      if (err.message === 'invalid_cep') {
        this.showMessage(this.dataset.invalidCep);
      } else if (err.message === 'cep_not_found') {
        this.showMessage(this.dataset.cepNotFound);
      } else {
        this.showMessage(this.dataset.viacepError);
      }
      return;
    }

    window.pdpCalculatingShipping = true;
    document.dispatchEvent(new CustomEvent('pdpShippingStarted'));

    this.showLoading(true);

    let originalCart = null;

    try {
      const cartResponse = await fetch('/cart.js');
      originalCart = await cartResponse.json();

      if (originalCart.items && originalCart.items.length > 0) {
        const updates = {};
        originalCart.items.forEach((item) => {
          updates[item.variant_id] = 0;
        });

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      const prepare = await fetch('/cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shipping_address: {
            country: 'Brazil',
            province: state,
            zip,
          },
        }),
      });

      if (!prepare.ok) {
        throw new Error('prepare');
      }

      await new Promise((res) => setTimeout(res, 4000));

      const ratesRes = await fetch('/cart/async_shipping_rates.json');
      const rates = await ratesRes.json();

      console.log(rates);

      if (rates && Object.keys(rates).length > 0) {
        this.renderRates(rates);
      } else if (this.resultsList) {
        this.resultsList.innerHTML = `<li>${this.dataset.noRates}</li>`;
        this.resultsBox.classList.remove('hidden');
      }
    } catch (err) {
      if (this.resultsList) {
        this.resultsList.innerHTML = `<li>${this.dataset.calculateError}</li>`;
        this.resultsBox.classList.remove('hidden');
      }
    } finally {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [variantId]: 0 } }),
        });

        if (originalCart && originalCart.items && originalCart.items.length > 0) {
          const restoreUpdates = {};
          originalCart.items.forEach((item) => {
            restoreUpdates[item.variant_id] = item.quantity;
          });

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: restoreUpdates }),
          });
        }
      } catch (e) {
        /* silencioso */
      }

      this.showLoading(false);
      window.pdpCalculatingShipping = false;
      document.dispatchEvent(new CustomEvent('pdpShippingCompleted'));
      setTimeout(() => {
        window.pdpCalculatingShipping = false;
      }, 500);
    }
  }

  formatDeliveryLabel(start, end) {
    const min = Number(start);
    const max = Number(end);

    if (!Number.isFinite(min) && !Number.isFinite(max)) {
      return '';
    }

    const applyTemplate = (template, vars) => {
      if (!template) return '';
      return Object.entries(vars).reduce(
        (str, [key, value]) => str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), value),
        template
      );
    };

    const isSingleDay =
      Number.isFinite(min) &&
      (!Number.isFinite(max) || min === max);

    if (isSingleDay) {
      const count = min;
      const template = count === 1 ? this.dataset.deliveryDateOne : this.dataset.deliveryDateMany;
      return applyTemplate(template, { count: String(count) });
    }

    if (Number.isFinite(min) && Number.isFinite(max)) {
      return applyTemplate(this.dataset.deliveryDateRange, {
        minimum: String(min),
        maximum: String(max),
      });
    }

    const count = Number.isFinite(min) ? min : max;
    const template = count === 1 ? this.dataset.deliveryDateOne : this.dataset.deliveryDateMany;
    return applyTemplate(template, { count: String(count) });
  }

  renderRates(rates) {
    if (!this.resultsBox || !this.resultsList) return;
    this.resultsBox.classList.remove('hidden');
    for (const key in rates) {
      rates[key].forEach((option) => {
        const price = parseFloat(option.price || 0);
        const deliveryStart = option.delivery_days?.[0];
        const deliveryEnd = option.delivery_days?.[1];
        const deliveryLabel = this.formatDeliveryLabel(deliveryStart, deliveryEnd);

        const li = document.createElement('li');
        li.className = 'shipping-pdp__rate-item';
        li.innerHTML = `
          <div class="shipping-pdp__rate-row">
            <strong class="shipping-pdp__rate-name">${option.presentment_name}</strong>
            <span class="shipping-pdp__rate-price">R$ ${price.toFixed(2).replace('.', ',')}</span>
          </div>
          ${deliveryLabel ? `<div class="shipping-pdp__rate-delivery"><small>${deliveryLabel}</small></div>` : ''}
        `;
        this.resultsList.appendChild(li);
      });
    }
  }

  showLoading(state) {
    if (!this.button || !this.spinner) return;
    if (state) {
      this.button.setAttribute('disabled', 'true');
      this.spinner.classList.remove('hidden');
    } else {
      this.button.removeAttribute('disabled');
      this.spinner.classList.add('hidden');
    }
  }
}

customElements.define('shipping-calculator-pdp', ShippingCalculatorPdp);
